<script setup lang="ts">
import { onErrorCaptured } from "vue";
import AppToast from "@/shared/components/AppToast.vue";

onErrorCaptured((err, _instance, _info) => {
  console.error("[App] Erro capturado:", err);
  // Não impede propagação — deixa o Vue logar no console
  return false;
});
</script>

<template>
  <router-view />
  <AppToast />
</template>
